import { Link, Outlet } from '@tanstack/react-router';
import { Bell, Home, LayoutDashboard, Wallet } from 'lucide-react';

export function CompactDashboardShell() {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 dark:bg-slate-950">
      {/* Top Header (Sensitive to Mobile) */}
      <header className="sticky top-0 z-40 flex h-14 items-center justify-between border-b bg-white px-4 dark:border-slate-800 dark:bg-slate-900">
        <span className="font-bold text-lg text-primary">OmniFlow</span>
        <div className="flex items-center gap-2">{/* Header actions can go here */}</div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 pb-16 pt-4 px-4 overflow-y-auto">
        <Outlet />
      </main>

      {/* Bottom Navigation Tab Bar (Touch-First) */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 flex h-16 items-center justify-around border-t bg-white px-2 dark:border-slate-800 dark:bg-slate-900 border-t-slate-200">
        <Link
          to="/m"
          activeProps={{ className: 'text-primary' }}
          inactiveProps={{ className: 'text-slate-500' }}
          className="flex flex-col items-center gap-1 p-2"
        >
          <Home className="h-6 w-6" />
          <span className="text-[10px] font-medium">Home</span>
        </Link>
        <Link
          to="/m/kpis"
          activeProps={{ className: 'text-primary' }}
          inactiveProps={{ className: 'text-slate-500' }}
          className="flex flex-col items-center gap-1 p-2"
        >
          <LayoutDashboard className="h-6 w-6" />
          <span className="text-[10px] font-medium">KPIs</span>
        </Link>
        <Link
          to="/m/alerts"
          activeProps={{ className: 'text-primary' }}
          inactiveProps={{ className: 'text-slate-500' }}
          className="flex flex-col items-center gap-1 p-2"
        >
          <Bell className="h-6 w-6" />
          <span className="text-[10px] font-medium">Alerts</span>
        </Link>
        <Link
          to="/m/wallet"
          activeProps={{ className: 'text-primary' }}
          inactiveProps={{ className: 'text-slate-500' }}
          className="flex flex-col items-center gap-1 p-2"
        >
          <Wallet className="h-6 w-6" />
          <span className="text-[10px] font-medium">Wallet</span>
        </Link>
      </nav>
    </div>
  );
}
